var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sig-wrapper"},[_c('canvas',{ref:"canvas",staticClass:"sig-canvas"})]),_c('div',{staticClass:"mt-3 d-flex justify-center"},[_c('v-btn',{attrs:{"small":"","color":"warning"},on:{"click":_vm.clear}},[_vm._v("Limpar")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }